import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import type { IContactRole } from '~/types/contact/models'
import type { TEntityId } from '~/types/models'

const supplierContactRoleListData = undefined as unknown as IContactRole[]

export const getSupplierContactRoleListData = getListDataFunctionFactory<
  IContactRole[]
>({
  listData: supplierContactRoleListData,
  storageKey: 'suppliercontactroles',
  getStartingListData: getStartingSupplierContactRoleListData,
})

export function _getSCRDataById(
  id: TEntityId,
  list: IContactRole[]
): IContactRole {
  if (!list) {
    throw new Error(`_getSCRDataById called with undefined/null list`)
  }
  const contactRole = list.find((cr: IContactRole) => cr.id === id)
  if (!contactRole) {
    throw new Error(`Can't find supplierContactRole '${id}'`)
  }
  return contactRole
}

export async function getSupplierContactRoleDataById(
  id: TEntityId
): Promise<IContactRole> {
  const list: IContactRole[] = await getSupplierContactRoleListData()
  if (!list) {
    throw new Error(`getSupplierContactRoleListData returned undefined/null`)
  }
  const c = list.find((supplierContactRole) => supplierContactRole.id === id)
  if (!c) {
    throw new Error(`Can't find supplierContactRole '${id}'`)
  }
  return c
}

export async function getSupplierContactRoleDataByLabel(
  label: string
): Promise<IContactRole> {
  const list: IContactRole[] = await getSupplierContactRoleListData()
  if (!list) {
    throw new Error(`getSupplierContactRoleListData returned undefined/null`)
  }
  const c = list.find(
    (supplierContactRole) => supplierContactRole.label === label
  )
  if (!c) {
    throw new Error(`Can't find supplierContactRole '${label}'`)
  }
  return c
}

export async function getStartingSupplierContactRoleListData(): Promise<
  IContactRole[]
> {
  return [
    { id: 'XXSCR001', hrid: 'SCR001', label: 'Primary', canBeDeleted: true },
    { id: 'XXSCR002', hrid: 'SCR002', label: 'Billing', canBeDeleted: true },
    { id: 'XXSCR003', hrid: 'SCR003', label: 'Liaison', canBeDeleted: true },
    {
      id: 'XXSCR004',
      hrid: 'SCR004',
      label: 'Project Manager',
      version: '1',
      canBeDeleted: true,
    },
  ]
}
